var THREE         = require("three");
var GlobalRotationHandleView  = require("./../abstract/globalRotationHandleView.js");
var lib_core      = require("lib-core");

var GlobalZRotationView = function (model, editorView, handleId, config) {
    GlobalRotationHandleView.call(this, model, editorView, handleId, config);

}

lib_core.inherit(GlobalZRotationView, GlobalRotationHandleView);

GlobalZRotationView.prototype.repositionMesh = function(mesh, position, rotation){
    var matrix = (new THREE.Matrix4())
    //matrix.makeRotationFromEuler(new THREE.Euler(
    //    rotation.x * Math.PI/180, 
    //    rotation.y * Math.PI/180, 
    //    0));
    matrix.setPosition( position.toThreejs() );
    mesh.matrix = matrix;
}

GlobalZRotationView.prototype.buildMesh = function(radius){
    var obj = new THREE.Object3D();
    obj.matrixAutoUpdate = false;

    var geom = this.buildSegGeometry(3)//.rotateX(Math.PI/2);
    var mesh = new THREE.Mesh(geom, this.material);
    
    obj.add(mesh);
    return obj;
}

GlobalZRotationView.prototype.hoverChanged = function(value){
    if(value){
        this.handleMesh.children[0].geometry = this.buildRingGeometry(3); 
    } else {
        this.handleMesh.children[0].geometry = this.buildSegGeometry(3); 
    }
} 

module.exports = GlobalZRotationView;

